import Answer from './mark-answer';
import Math from './mark-math';
import Language from './mark-language';

export const MarkTypes = {
  // NOTE: our own mark
  Answer: Answer.type,
  math: Math.type,
  language: Language.type,
  // NOTE: titap mark
};

export default [Answer.mark, Math.mark, Language.mark];
